import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { THEME_MESSAGES } from 'utils/constants';
import { getEntitlementAuditTrail } from 'api/admin/businesses/entitlements';
import { ApiError } from 'types/api';
import {
  EntitlementAuditTrailParams,
  EntitlementAuditTrailResponse,
} from 'types/entitlements/entitlements';

export const ENTITLEMENT_AUDIT_TRAIL_QUERY_KEY = 'entitlementAuditTrail';

export const useEntitlementAuditTrail = ({
  businessId,
  page,
  storeId,
}: EntitlementAuditTrailParams) => {
  return useQuery<EntitlementAuditTrailResponse, ApiError>({
    queryKey: [ENTITLEMENT_AUDIT_TRAIL_QUERY_KEY, businessId, page, storeId],
    queryFn: async () => {
      const { data } = await getEntitlementAuditTrail({ businessId, page, storeId });

      return data;
    },
    enabled: !!businessId,
    // Both 404s are final, and a retry would delay the error by seconds.
    retry: false,
    refetchOnWindowFocus: false,
    // Keeps the current page on screen while the next one loads.
    keepPreviousData: true,
    onError: (error) => {
      Sentry.captureException(error);
      // Both 404s (an unknown business, a store outside it) carry a message naming which.
      toast.error(error?.response?.data?.error ?? THEME_MESSAGES.somethingWrong, {
        duration: 4000,
      });
    },
  });
};
